import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "bg-white rounded-lg space-y-3" }
const _hoisted_2 = { class: "flex items-center gap-2" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  class: "w-4 h-4",
  viewBox: "0 0 20 20",
  fill: "currentColor"
}
const _hoisted_5 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  class: "w-4 h-4",
  viewBox: "0 0 20 20",
  fill: "currentColor"
}
const _hoisted_6 = {
  key: 2,
  xmlns: "http://www.w3.org/2000/svg",
  class: "w-4 h-4",
  viewBox: "0 0 20 20",
  fill: "currentColor"
}
const _hoisted_7 = { class: "flex flex-wrap items-center gap-2" }
const _hoisted_8 = ["onClick"]

import { computed } from "vue"
import { useTasksStore } from "@/stores/v2"


export default /*@__PURE__*/_defineComponent({
  __name: 'TasksFilter',
  setup(__props) {

const filters = computed(() => useTasksStore().getFilters);
const activeFilter = computed(() => useTasksStore().getActiveFilter)
const typeFilters = computed(() => useTasksStore().getTypeFilters);
const activeTypeFilter = computed(() => useTasksStore().getActiveTypeFilter);

const handleClick = (term: string) => {
  useTasksStore().setActiveFilter(term)
}

const handleTypeClick = (term: string) => {
  useTasksStore().setActiveTypeFilter(term);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filters.value, (filter) => {
        return (_openBlock(), _createElementBlock("li", {
          key: filter.name,
          class: "flex-1",
          onClick: ($event: any) => (handleClick(filter.term))
        }, [
          _createElementVNode("button", {
            class: _normalizeClass(["w-full ring-1 ring-gray-200 border-gray p-3 rounded-lg flex items-center justify-center gap-2 font-medium transition-all duration-200", {
            'bg-gray-50 text-gray-600 hover:bg-gray-100 hover:text-gray-700': activeFilter.value !== filter.term,
            'bg-primary text-white shadow-md hover:bg-primary/90': activeFilter.value === filter.term,
          }])
          }, [
            (filter.term === 'pending')
              ? (_openBlock(), _createElementBlock("svg", _hoisted_4, _cache[0] || (_cache[0] = [
                  _createElementVNode("path", { d: "M9 2a1 1 0 000 2h2a1 1 0 100-2H9z" }, null, -1),
                  _createElementVNode("path", {
                    "fill-rule": "evenodd",
                    d: "M4 5a2 2 0 012-2 3 3 0 003 3h2a3 3 0 003-3 2 2 0 012 2v11a2 2 0 01-2 2H6a2 2 0 01-2-2V5zm3 4a1 1 0 000 2h.01a1 1 0 100-2H7zm3 0a1 1 0 000 2h3a1 1 0 100-2h-3zm-3 4a1 1 0 100 2h.01a1 1 0 100-2H7zm3 0a1 1 0 100 2h3a1 1 0 100-2h-3z",
                    "clip-rule": "evenodd"
                  }, null, -1)
                ])))
              : _createCommentVNode("", true),
            (filter.term === 'finished')
              ? (_openBlock(), _createElementBlock("svg", _hoisted_5, _cache[1] || (_cache[1] = [
                  _createElementVNode("path", {
                    "fill-rule": "evenodd",
                    d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z",
                    "clip-rule": "evenodd"
                  }, null, -1)
                ])))
              : _createCommentVNode("", true),
            (filter.term === 'scheduled')
              ? (_openBlock(), _createElementBlock("svg", _hoisted_6, _cache[2] || (_cache[2] = [
                  _createElementVNode("path", {
                    "fill-rule": "evenodd",
                    d: "M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z",
                    "clip-rule": "evenodd"
                  }, null, -1)
                ])))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(filter.name), 1)
          ], 2)
        ], 8, _hoisted_3))
      }), 128))
    ]),
    _createElementVNode("ul", _hoisted_7, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(typeFilters.value, (typeFilter) => {
        return (_openBlock(), _createElementBlock("li", {
          key: typeFilter.term
        }, [
          _createElementVNode("button", {
            class: _normalizeClass(["ring-1 ring-gray-200 border-gray px-3 py-1.5 rounded-lg text-sm font-medium transition-all duration-200", {
            'bg-gray-50 text-gray-600 hover:bg-gray-100 hover:text-gray-700': activeTypeFilter.value !== typeFilter.term,
            'bg-primary text-white shadow-sm hover:bg-primary/90': activeTypeFilter.value === typeFilter.term,
          }]),
            onClick: ($event: any) => (handleTypeClick(typeFilter.term))
          }, _toDisplayString(typeFilter.name), 11, _hoisted_8)
        ]))
      }), 128))
    ])
  ]))
}
}

})